import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import PrivateRoute from '../../routes/PrivateRoute';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));

const ContentRoutes = () => {
    return (
        <Routes>
            {/* Render Public Routes */}
            {contents.publicRoutes.map((page) => (
                <Route key={page.path} {...page} />
            ))}
            
            {/* Render Private Routes with PrivateRoute wrapper */}
            {contents.privateRoutes.map((page) => (
                <Route 
                    key={page.path} 
                    path={page.path} 
                    element={
                        <PrivateRoute>
                            {page.element}
                        </PrivateRoute>
                    } 
                />
            ))}
            
            <Route path='*' element={<PAGE_404 />} />
        </Routes>
    );
};

export default ContentRoutes;